// Error Modal constants
export const CREATION_ERROR = 'creation';
export const API_ERROR = 'api';
export const ENTITLEMENT_ERROR = 'entitlement';
